import { isWx, submitPostForm } from "./tools";
import { Notify } from "../components/index";

export const appid = window._config.var.appid;

// 移动端用
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const wxLogin = (path?: any) => {
  // const pathname = path ? path : `${location.pathname}${location.search}`;
  // const origin = `${location.origin}${pathname}`;
  if (isWx()) {
    const url = `https://www.aihaohaoyong.com/wechatservice/get_user_info?origin=${window.location.origin}/wechatservice/login`;
    window.location.href = url;
    // submitPostForm(url, {
    //   [(document.querySelector(`meta[name="csrf-param"]`) as any).content]: (
    //     document.querySelector(`meta[name="csrf-token"]`) as any
    //   ).content,
    // });
  } else {
    Notify.error({
      message: "请在微信环境下访问",
      className: "notify-not-description",
      duration: 3,
    });
  }
};

export const initWxCode = () => {
  const wxLogin = (window as any).WxLogin;
  if (wxLogin) {
    setTimeout(() => {
      new wxLogin({
        self_redirect: false,
        id: "code-node",
        appid,
        scope: "snsapi_login",
        redirect_uri: encodeURIComponent(
          `https://aihaohaoyong.com/auth/wechat/callback?origin_url=${location.href}`
        ),
        state: Math.ceil(Math.random() * 1000),
        // 为 1 href 会失效
        stylelite: 1,
        style: "black",
        // href: "data:text/css;base64,LndlYl9xcmNvZGVfaW1nIHsgd2lkdGg6IDIwMHB4OyBoZWlnaHQ6IDIwMHB4IH0KLndlYl9xcmNvZGVfaW1nX3dycCB7IGJvcmRlcjogMXB4IHNvbGlkICNlMmUyZTIgfQo=",
      });
    });
  }
};
